<script lang="ts">
    import { mdiMenuDown, mdiMenuRight } from "@mdi/js"
    import { getDBEntry } from "../../api"
    import { spaLink } from "../actions"
    import { navigationCache, location } from "../store"
    import Icon from "./Icon.svelte"

    let navigationEntry: NavigationEntry

    function elementsToCache(elements: NavigationElement[]) {
        elements.forEach((el) => {
            if (!el.external) {
                if (!$navigationCache[el.page]) {
                    // only first hit to cache
                    $navigationCache[el.page] = el
                }
                if (el.elements?.length > 0) {
                    elementsToCache(el.elements)
                }
            }
        })
    }
    getDBEntry("navigation", {
        tree: 0,
    }).then((nav) => {
        navigationEntry = nav
        elementsToCache(nav.elements)
    })

    let navOpen = false

    let subNavOpen: { [key: number]: boolean } = {}

    $: if (!navOpen) {
        // close all hidden subNavs
        subNavOpen = {}
    }

    let windowWidth: number

    $: isMobile = windowWidth < 1024

    // close on location change
    $: if ($location) {
        navOpen = false
    }

    let y = 0
    let lastY = 0

    function updateHeader(y: number) {
        const dy = lastY - y
        lastY = y
        if (Math.abs(dy) <= 0) {
            // no movement
            return ""
        } else if (y <= 0) {
            // top
            return ""
        } else if (dy < 0) {
            return "moveUp"
        } else {
            return ""
        }
    }

    $: headerClass = updateHeader(y)
</script>

<svelte:window bind:innerWidth="{windowWidth}" bind:scrollY="{y}" />

<header class="smooth-shadow {headerClass}">
    <div class="main-nav-outer">
        <div class="nav-wrapper justify-space-between align-center">
            <div class="col">
                <a use:spaLink href="/">
                    <img src="/assets/img/logo.png" style="" alt="Rechtec Logo" />
                </a>
            </div>
            <!-- hamburger menu -->
            <button
                class="hamburger"
                aria-label="Open Menu"
                class:active="{navOpen}"
                on:click="{() => (navOpen = !navOpen)}"
            >
                <span></span>
                <span></span>
                <span></span>
            </button>
            <!-- soll Mobiles Menü öffnen -->
            {#if navigationEntry?.elements?.length > 0}
                <nav class="col main-nav" class:show="{navOpen}">
                    <!-- als Menü erstellen, + Klasse show in mobiler Darstellung -->
                    <ul>
                        {#each navigationEntry.elements as navL1, l1idx}
                            <li class="nav-item" class:has-submenu="{navL1.elements?.length > 0}">
                                <!-- has-submenu selbsterklärend -->
                                <!-- if $location.path begins with navL1.page set active class -->
                                <a
                                    use:spaLink
                                    data-spa-prevent="{isMobile && navL1.elements?.length > 0}"
                                    href="{navL1.external
                                        ? navL1.externalUrl
                                        : navL1.page + (navL1.hash ? '#' + navL1.hash : '')}"
                                    target="{navL1.external ? '_blank' : '_self'}"
                                    class:external="{navL1.external}"
                                    class:active="{$location.path.startsWith(navL1.page)}"
                                    aria-expanded="{subNavOpen[l1idx] ? 'true' : 'false'}"
                                    on:click="{(e) => {
                                        if (isMobile) e.preventDefault()
                                        subNavOpen[l1idx] = !subNavOpen[l1idx]
                                    }}"
                                    ><span>{navL1.name}</span>

                                    {#if navL1.elements?.length > 0}
                                        <button
                                            on:click|stopPropagation|preventDefault="{(e) => {
                                                if (isMobile) e.preventDefault()
                                                subNavOpen[l1idx] = !subNavOpen[l1idx]
                                            }}"
                                        >
                                            {#if subNavOpen[l1idx] || !isMobile}
                                                <Icon path="{mdiMenuDown}" size="24px" />
                                            {:else}
                                                <Icon path="{mdiMenuRight}" size="24px" />
                                            {/if}
                                        </button>
                                    {/if}
                                </a>
                                {#if navL1.elements?.length > 0}
                                    <ul class="sub-menu" class:show="{subNavOpen[l1idx]}">
                                        {#if isMobile}
                                            <li>
                                                <a
                                                    use:spaLink
                                                    href="{navL1.external
                                                        ? navL1.externalUrl
                                                        : navL1.page + (navL1.hash ? '#' + navL1.hash : '')}"
                                                    target="{navL1.external ? '_blank' : '_self'}"
                                                    class:active="{$location.path === navL1.page}"
                                                    on:click="{() => {
                                                        navOpen = false
                                                    }}"
                                                    class:external="{navL1.external}">Übersicht</a
                                                >
                                            </li>
                                        {/if}
                                        {#each navL1.elements as navL2}
                                            <li>
                                                <a
                                                    use:spaLink
                                                    href="{navL2.external
                                                        ? navL2.externalUrl
                                                        : navL2.page + (navL2.hash ? '#' + navL2.hash : '')}"
                                                    target="{navL2.external ? '_blank' : '_self'}"
                                                    on:click="{() => {
                                                        navOpen = false
                                                    }}"
                                                    class:external="{navL2.external}">{navL2.name}</a
                                                >
                                            </li>
                                        {/each}
                                    </ul>
                                {/if}
                            </li>
                        {/each}
                    </ul>
                </nav>
            {/if}
        </div>
    </div>
</header>

<style lang="less">
    header {
        width: 100%;
        z-index: 9999;
        * {
            transition: color 0.2s;
        }
        background: var(--white-100);
        padding: 24px 0px;
        height: 62px;
        display: flex;
        justify-content: center;
        box-shadow: var(--dropshadow);
        border-radius: var(--border-radius);
        position: sticky;
        top: 0;

        .container {
            .grid {
                margin: 0;
                @media (max-width: 767px) {
                    gap: 10px;
                }
            }
        }
        a {
            display: flex;
            align-items: center;
            justify-content: flex-start;
            img {
                max-height: 72px;
                object-fit: contain;
                height: 100%;
                width: auto;
                @media (max-width: 600px) {
                    max-height: 48px;
                }
            }
        }
        .main-nav-outer {
            width: 100%;
            display: flex;
            justify-content: center;
            align-items: center;

            max-width: var(--normal-max-width);
            margin: 0px var(--horizontal-default-margin);
            .nav-wrapper {
                display: flex;
                justify-content: space-between;
                width: 100%;
            }
        }
        button.hamburger {
            display: none;
            @media (max-width: 1024px) {
                display: block;
                z-index: 999;
                background: transparent;
                border: 0;

                outline: 0;
                span {
                    display: block;
                    width: 24px;
                    height: 2px;
                    margin: 6px 0;
                    background-color: var(--grey-100);
                }
                &.active {
                    span:nth-child(1) {
                        transform: rotate(45deg) translate(5px, 5px);
                    }
                    span:nth-child(2) {
                        opacity: 0;
                    }
                    span:nth-child(3) {
                        transform: rotate(-45deg) translate(7px, -7px);
                    }
                }
            }
        }

        .main-nav {
            width: 100%;
            display: flex;
            justify-content: flex-end;

            > ul {
                display: flex;
                gap: 24px;
                list-style: none;
                list-style-type: none;
                margin: 0;
                padding: 0;
                > li {
                    padding: 0;
                    margin: 0;
                    position: relative;
                    display: flex;
                    align-items: flex-start;
                    > a {
                        padding-top: 29px;
                        text-transform: uppercase;
                        font-weight: 400;
                        display: flex;
                        flex-direction: column;
                        align-items: center;
                        color: var(--grey-100);
                        &:after {
                            content: "";
                            display: block;
                            width: 100%;
                            height: 2px;
                            background-size: 200% 100%;
                        }
                        button {
                            background-color: transparent;
                            border: 0px;
                            padding: 0px;
                            flex-grow: 1;
                            display: flex;
                            justify-content: flex-end;
                        }
                        &:hover,
                        &.active {
                            color: var(--orange-100);
                            button {
                                color: var(--orange-100);
                            }
                            &:after {
                                background-position: left;
                            }
                        }
                        &.external {
                            display: flex;
                            padding: 12px 24px;
                            justify-content: center;
                            align-items: center;
                            border-radius: 12px 2px;
                            background: var(--orange-100);
                            line-height: 0.7rem;
                            margin: auto 0px auto calc(var(--default-gap) / 2);
                            color: var(--white-100);

                            width: 100%;
                            @media (max-width: 1024px) {
                                padding: 12px 0px;
                                margin: 0px;
                                margin-top: calc(var(--default-gap) / 2);
                            }
                        }
                    }
                    ul.sub-menu {
                        display: none;
                        position: absolute;
                        box-shadow: 0px 0px 48px 0px rgba(89, 103, 111, 0.24);
                        top: 100%;
                        left: 0;
                        background: var(--grey-100);
                        color: var(--white-100);
                        border-radius: 6px 6px 24px 6px;
                        padding: 0px 24px 0px 24px;
                        list-style: none;
                        list-style-type: none;
                        margin: 0;
                        flex-flow: column;
                        align-items: flex-end;

                        li {
                            padding: 12px 0px;
                            a {
                                color: var(--white-100);

                                display: block;
                                white-space: nowrap;
                                &:hover {
                                    color: var(--orange-100);
                                }
                                &.external {
                                    display: flex;
                                    justify-content: flex-end;
                                    align-items: center;
                                    gap: 10px;
                                    &:after {
                                        content: "";
                                        display: block;
                                        width: 14px;
                                        height: 14px;
                                        background-size: 100%;
                                        background-position: center;
                                        flex-shrink: 0;
                                    }
                                }
                            }
                        }
                    }
                    &:hover {
                        > a {
                            &:after {
                                background-position: left;
                            }
                        }
                        @media (min-width: 1024px) {
                            ul.sub-menu {
                                display: block;
                            }
                        }
                    }
                }
            }
            @media (max-width: 1024px) {
                display: none;
                position: absolute;
                top: 66px !important;
                left: 0px;
                width: 100vw;
                max-width: 100vw;

                background: #fff;

                z-index: 998;
                > ul {
                    padding: 20px 30px 48px 30px;
                    width: 100%;
                    margin: 0px calc(-1 * var(--horizontal-default-margin));
                    max-width: calc(100% - 48px);
                    flex-flow: column;
                    gap: 0px;
                    align-items: flex-end;
                    > li {
                        width: 100%;
                        max-width: 100%;
                        display: initial;
                        &:not(.has-submenu) {
                            &:after {
                                content: "";
                                display: block;
                                width: 100%;
                                height: 2px;
                                background-size: 200% 100%;
                            }
                            &:hover {
                                &:after {
                                    background-position: left;
                                }
                            }
                        }
                        a {
                            padding: 12px 0;
                            width: 100%;
                            max-width: 100%;
                            font-size: 1em;
                            font-style: normal;
                            display: flex;
                            flex-direction: row;
                            align-items: center;
                            justify-content: space-between;
                            &:after {
                                display: none !important;
                            }
                        }
                        &.has-submenu {
                            > a {
                                &:after {
                                    content: "";
                                    display: block;
                                    width: 24px;
                                    height: 24px;
                                    float: right;
                                }
                                &[aria-expanded="true"] {
                                    &:after {
                                        transform: rotate(180deg);
                                    }
                                }
                            }
                            &:hover {
                                ul.sub-menu {
                                    &:after {
                                        background-position: left;
                                    }
                                }
                            }
                        }
                        ul.sub-menu {
                            display: none;
                            position: relative;
                            top: 0;
                            padding-left: 24px;
                            &:before {
                                content: "";
                                display: block;
                                width: 100%;
                                height: 2px;
                                background-size: 200% 100%;
                            }
                            &.show {
                                list-style: none;
                                list-style-type: none;
                                width: fit-content;
                                background: transparent;
                                box-shadow: none;
                                color: var(--grey-100);

                                margin: 0;
                                display: flex;
                                flex-direction: column;
                                align-items: flex-start;
                                width: 100%;
                                li {
                                    padding: 5px 0px;
                                    display: flex;
                                    justify-content: space-between;
                                    width: 100%;
                                    a {
                                        color: var(--grey-100);
                                        display: flex;
                                        padding: 0px;
                                        justify-content: flex-start;
                                        button {
                                        }
                                    }
                                    &:before {
                                        background-position: left;
                                    }

                                    // make at end of every li chevron right
                                    &:after {
                                        content: "❯";
                                        display: block;
                                        width: 24px;
                                        height: 24px;
                                        margin-right: 14px;
                                        background-position: center;
                                        flex-shrink: 0;
                                    }
                                }
                            }
                        }
                    }
                }
                &.show {
                    display: flex;
                    justify-content: center;
                    top: 100%;
                }
            }
        }
    }
</style>
